
export enum DebtorCd {
	BILL_TO_IS_DEBTOR = 'BillToIsDebtor',
	CONSIGNEE_IS_DEBTOR = 'ConsigneeIsDebtor',
	DEBTOR_NOT_DETERMINED = 'DebtorNotDetermined',
	NO_DEBTOR = 'NoDebtor',
	SHIPPER_IS_DEBTOR = 'ShipperIsDebtor'}

